<template>
  <div>
    <div class="app-container order-info">
    <el-form inline :model="orderInfo" label-width="120px">
      <div class="title">{{$t('MyOrder.OrderCenter')}}
        <el-button @click="backAndClose" style="float:right;">{{$t('back')}}</el-button>
      </div>
      <div class="search-form-inline">
        <el-row class="mb20">
          <el-col :span="6">
            <el-form-item class="mb0" :label="$t('MyOrder.OrderNumber') + '：'">
              <span>{{orderInfo.orderNo}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item class="mb0" :label="$t('MyOrder.OrderStatus') + '：'">
              <span>{{orderInfo.status}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item class="mb0" :label="$t('MyOrder.CreationDate') + '：'">
              <span>{{orderInfo.saleTime}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item class="mb0" :label="$t('MyOrder.Contactphonenumber') + '：'">
              <span class="flex-center">
                <span v-if="orderInfo.contactMobile2">{{ orderInfo.contactMobile2 }}</span>
                <span v-else>{{ orderInfo.contactMobile }}</span>
                <i
                  v-if="orderInfo.contactMobile && orderInfo.contactMobile2 && orderInfo['contactMobile' +'Encrypt']"
                  class="el-icon-view viewOperate blue pointer"
                  @click="decrypt(orderInfo, 'contactMobile')"
                />
                <i
                  v-if="orderInfo.contactMobile && !orderInfo.contactMobile2 && orderInfo['contactMobile' +'Encrypt']"
                  class="el-icon-view viewOperate closed pointer"
                  @click="decrypt(orderInfo, 'contactMobile')"
                />
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item class="mb0" label="订单金额：">
              <span>￥{{orderInfo.itemTotal}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item class="mb0" label="实付金额：">
              <span>￥{{orderInfo.paymentTotal}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item class="mb0" label="退款金额：">
              <span>￥{{orderInfo.realRefundTotalAmound}}</span>
            </el-form-item>
          </el-col>
           <el-col :span="6">
            <el-form-item class="mb0" :label="$t('MyOrder.Handlingfee') + '：'">
              <span>￥{{orderInfo.refundTotalPoundage}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <el-table class="ticket" border header-row-class-name='parent-head-style' :key='tableKey' :data='tripOrderTicketInfoDOList' v-loading.body='listLoading' fit highlight-current-row style='width: 100%'>
        <el-table-column align='center' :label="$t('FillOrder.productName')" width="160">
            <template slot-scope='scope'>
                <span>{{scope.row.ticketName}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' :label="$t('FillOrder.ticketType')" width="160">
            <template slot-scope='scope'>
                <span>{{scope.row.ticketKindName}}</span>
            </template>
        </el-table-column>
        <el-table-column  v-if="showTicketNo" align='center' width="160" :label="$t('MyOrder.Ticketnumber')">
            <template slot-scope='scope'>
                <span>{{scope.row.ticketNo}}</span>
            </template>
        </el-table-column>
          <el-table-column  v-if="showTicketNo" align='center' width="160" :label="$t('MyOrder.TicketcheckingQRcode')">
            <template v-if="scope.row.ticketNo && scope.row.isReplenished !== 'T'" slot-scope='scope'>
                <img class="pointer" @click="qrCode(scope.row)" src="../assets/images/home/qccode.png" />
            </template>
        </el-table-column>
        <el-table-column align='center' :label="$t('MyOrder.Effectivedate')" width="160">
            <template slot-scope='scope'>
                <span>{{scope.row.earliestEffectiveCheckDate}} - {{scope.row.lastEffectiveCheckDate}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' :label="$t('MyOrder.Effectivetime')" width="160">
            <template slot-scope='scope'>
                <span>{{scope.row.earliestEffectiveCheckTime}} - {{scope.row.lastEffectiveCheckTime}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' :label="$t('FillOrder.Name')">
            <template slot-scope='scope'>
              <span class="flex-center">
                <span v-if="scope.row.visitorName2">{{ scope.row.visitorName2 }}</span>
                <span v-else>{{ scope.row.visitorName }}</span>
                <i
                  v-if="scope.row.visitorName && scope.row.visitorName2 && scope.row['visitorName' +'Encrypt']"
                  class="el-icon-view viewOperate blue pointer"
                  @click="decrypt(scope.row, 'visitorName')"
                />
                <i
                  v-if="scope.row.visitorName && !scope.row.visitorName2 && scope.row['visitorName' +'Encrypt']"
                  class="el-icon-view viewOperate closed pointer"
                  @click="decrypt(scope.row, 'visitorName')"
                />
              </span>
            </template>
        </el-table-column>
        <el-table-column align='center' width="160" :label="$t('FillOrder.IDNumber')">
            <template slot-scope='scope'>
              <span class="flex-center">
                <span v-if="scope.row.visitorCertificateNo2">{{ scope.row.visitorCertificateNo2 }}</span>
                <span v-else>{{ scope.row.visitorCertificateNo }}</span>
                <i
                  v-if="scope.row.visitorCertificateNo && scope.row.visitorCertificateNo2 && scope.row['visitorCertificateNo' +'Encrypt']"
                  class="el-icon-view viewOperate blue pointer"
                  @click="decrypt(scope.row, 'visitorCertificateNo')"
                />
                <i
                  v-if="scope.row.visitorCertificateNo && !scope.row.visitorCertificateNo2 && scope.row['visitorCertificateNo' +'Encrypt']"
                  class="el-icon-view viewOperate closed pointer"
                  @click="decrypt(scope.row, 'visitorCertificateNo')"
                />
              </span>
            </template>
        </el-table-column>
        <el-table-column align='center' width="160" label='出行人手机号'>
            <template slot-scope='scope'>
              <span class="flex-center">
                <span v-if="scope.row.visitorMobile2">{{ scope.row.visitorMobile2 }}</span>
                <span v-else>{{ scope.row.visitorMobile }}</span>
                <i
                  v-if="scope.row.visitorMobile && scope.row.visitorMobile2 && scope.row['visitorMobile' +'Encrypt']"
                  class="el-icon-view viewOperate blue pointer"
                  @click="decrypt(scope.row, 'visitorMobile')"
                />
                <i
                  v-if="scope.row.visitorMobile && !scope.row.visitorMobile2 && scope.row['visitorMobile' +'Encrypt']"
                  class="el-icon-view viewOperate closed pointer"
                  @click="decrypt(scope.row, 'visitorMobile')"
                />
              </span>
            </template>
        </el-table-column>
        <el-table-column align='center' :label="$t('MyOrder.Numberofpeople')">
            <template slot-scope='scope'>
                <span>{{scope.row.allowPersonCount}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' :label="$t('MyOrder.Numberoftimes')">
            <template slot-scope='scope'>
                <span>{{scope.row.allowEnterCount}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' width="160" :label="$t('MyOrder.Ticketcollectiondate')">
            <template slot-scope='scope'>
                <span>{{scope.row.ticketPickupTime}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' :label="$t('MyOrder.Numberofprints')">
            <template slot-scope='scope'>
                <span>{{scope.row.printCounts}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' :label="$t('MyOrder.Numberofticketschecked')">
            <template slot-scope='scope'>
                <span>{{scope.row.checkedTicketCounts}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' :label="$t('Ticketcollectionstatus')">
            <template slot-scope='scope'>
                <span>{{scope.row.ticketPickupStatus === 'T' ? $t('Pickedup'):$t('NotPickup') }}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' :label="$t('MyOrder.Ticketstatus')">
            <template slot-scope='scope'>
                <span>{{scope.row.status}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' label='补票状态'>
            <template slot-scope='scope'>
                <span>{{scope.row.isReplenished==='T'?'已补票':'未补票'}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' fixed="right" :label="$t('MyOrder.Operating')" width='120'>
            <template slot-scope='scope'>
                <span class='blue pointer' @click="handleCheckInfo(scope.row)">{{$t('MyOrder.Checkingrecords')}}</span><br/>
                <span class='blue pointer' v-if="scope.row.carryChildrenCount" @click="handleChildrenInfo(scope.row)">携带儿童信息</span>
            </template>
        </el-table-column>
    </el-table>
    <el-dialog :title="$t('MyOrder.Checkininformation')" left width="70%" :visible.sync="dialogCompVisible" class="dialog-p20">
        <el-form :model="form" ref="form" >
            <el-row class="mb0">
                <el-col :span="8">
                    <el-form-item  :label="$t('MyOrder.Ticketnumber') + '：'">
                        <span>{{form.ticketNo}}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item  :label="$t('FillOrder.IDNumber') + '：'">
                      <span class="flex-center">
                        <span v-if="visitorCertificateNo2">{{ visitorCertificateNo2 }}</span>
                        <span v-else>{{ visitorCertificateNo }}</span>
                        <i
                          v-if="visitorCertificateNo && visitorCertificateNo2 && visitorCertificateNoEncrypt"
                          class="el-icon-view viewOperate blue pointer"
                          @click="decrypt2(1)"
                        />
                        <i
                          v-if="visitorCertificateNo && !visitorCertificateNo2 && visitorCertificateNoEncrypt"
                          class="el-icon-view viewOperate closed pointer"
                          @click="decrypt2(1)"
                        />
                    </span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-table header-row-class-name='parent-head-style' :key='tableKey' :data='checkInfo' v-loading.body='listLoading' fit highlight-current-row style='width: 100%'>
                <el-table-column align='center' :label="$t('Ticketcheckintype')">
                    <template slot-scope='scope'>
                        <span>{{scope.row.validationType}}</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' :label="$t('Ticketcheckmedia')">
                    <template slot-scope='scope'>
                        <span>{{scope.row.checkType}}</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' :label="$t('Ticketidentificationnumber')" width="160">
                    <template slot-scope='scope'>
                        <span>{{scope.row.checkNo}}</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' :label="$t('Checkindate')">
                    <template slot-scope='scope'>
                        <span>{{scope.row.checkDate}}</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' :label="$t('Checkintime')">
                    <template slot-scope='scope'>
                        <span>{{scope.row.checkTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' :label="$t('Checkpointname')">
                    <template slot-scope='scope'>
                        <span>{{scope.row.checkStationName}}</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' :label="$t('MyOrder.Numberofpeople')">
                    <template slot-scope='scope'>
                        <span>{{scope.row.personCount}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">{{$t('MyOrder.Close')}}</el-button>
        </div>
    </el-dialog>
    <el-dialog title="携带儿童票信息" left width="70%" :visible.sync="childrenShow" class="dialog-p20">
      <el-table
          header-row-class-name="parent-head-style"
          :key="tableKey"
          :data="childrenList"
          v-loading.body="listLoading"
          fit
          highlight-current-row
          style="width: 100%"
        >
          <el-table-column align="center" label="姓名">
            <template slot-scope="scope">
              <span class="flex-center">
                <span v-if="scope.row.name2">{{ scope.row.name2 }}</span>
                <span v-else>{{ scope.row.name }}</span>
                <i
                  v-if="scope.row.name && scope.row.name2 && scope.row['name' +'Encrypt']"
                  class="el-icon-view viewOperate blue pointer"
                  @click="decrypt(scope.row, 'name')"
                />
                <i
                  v-if="scope.row.name && !scope.row.name2 && scope.row['name' +'Encrypt']"
                  class="el-icon-view viewOperate closed pointer"
                  @click="decrypt(scope.row, 'name')"
                />
            </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="证件类型">
            <template slot-scope="scope">
              <span>{{scope.row.certificateType}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="证件号">
            <template slot-scope="scope">
              <span class="flex-center">
                <span v-if="scope.row.certificateNo2">{{ scope.row.certificateNo2 }}</span>
                <span v-else>{{ scope.row.certificateNo }}</span>
                <i
                  v-if="scope.row.certificateNo && scope.row.certificateNo2 && scope.row['certificateNo' +'Encrypt']"
                  class="el-icon-view viewOperate blue pointer"
                  @click="decrypt(scope.row, 'certificateNo')"
                />
                <i
                  v-if="scope.row.certificateNo && !scope.row.certificateNo2 && scope.row['certificateNo' +'Encrypt']"
                  class="el-icon-view viewOperate closed pointer"
                  @click="decrypt(scope.row, 'certificateNo')"
                />
            </span>
            </template>
          </el-table-column>
        </el-table>
    </el-dialog>
    <div class="qrcode-box" v-show="qrcode" @click="qrcode = false">
      <div class="qc-box-2">
        <div class="icon"><img src="../assets/images/home/whiteCode.png" /></div>
        <div class="title-text" v-if="qcCodeSelect">
          <p class="p1">{{qcCodeSelect.ticketName}}</p>
          <p class="p2">{{qcCodeSelect.ticketKindName}}</p>
          <p class="userName">{{qcCodeSelect.visitorName}}</p>
        </div>
        <div id="qrcode"  class="qrcode"></div>
        <div class="hint">提示:虚线框内为建议截图，拍照范围</div>
        <!-- <el-button @click="qrcode = false">关闭</el-button> -->
        <img class="closeIcon" @click="qrcode = false" src="../assets/images/home/close.png"/>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { getDetail, getTicketDetail, getCheckLogList, handleChildrenInfo } from '@/api/myOrder'
import QRCode from 'qrcodejs2'
import { decryptMixin } from '@/mixins/decryptMixin'
import { decrypt } from '@/api/buyTicket'
export default {
  name: 'orderListDetail',
  mixins: [decryptMixin],
  data () {
    return {
      listLoading: false,
      orderInfo: {},
      tripOrderTicketInfoDOList: null,
      showTicketNo: false,
      tableKey: 0,
      list: [],
      activeTabs: 'ticketInfo',
      dialogCompVisible: false,
      checkInfo: [],
      form: {},
      status: [],
      checkType: [],
      qrcode: false,
      qcCodeSelect: null,
      childrenList: [],
      childrenShow: false,
      visitorCertificateNo: null,
      visitorCertificateNo2: null,
      visitorCertificateNoEncrypt: null
    }
  },
  props: ['orderNo'],
  created () {
    const orderNo = this.orderNo
    this.handleQueryDetail(orderNo)
    this.getTicketDetail(orderNo)
  },
  computed: {},
  components: {},
  methods: {
    decrypt2 (type) {
      if (!this.visitorCertificateNo2) {
        const param = [this.visitorCertificateNoEncrypt]
        decrypt(param).then(res => {
          if (res.code === 0) {
            this.visitorCertificateNo2 = res.data[0]
          } else {
            this.$message.error(res.error)
          }
        })
      } else {
        this.visitorCertificateNo2 = null
      }
    },
    handleQueryDetail (orderNo) {
      getDetail({
        orderNo
      }).then(res => {
        if (res.code === 0) {
          this.orderInfo = res.data
        } else {
          this.$message.error('请求出错了')
        }
      })
    },
    getTicketDetail (orderNo) {
      getTicketDetail({
        orderNo
      }).then(res => {
        if (res.code === 0) {
          this.tripOrderTicketInfoDOList = res.data
          this.showTicketNo = this.tripOrderTicketInfoDOList.some(val => val.isShowBarcode && val.isShowBarcode !== 'F')
        }
      })
    },
    handleReturn () {
      this.$router.push({
        path: 'orderList'
      })
    },
    handleCheckInfo (record) {
      this.dialogCompVisible = true
      this.form = {
        ticketNo: record.ticketNo,
        visitorCertificateNo: record.visitorCertificateNo
      }
      this.visitorCertificateNo = record.visitorCertificateNo
      this.visitorCertificateNoEncrypt = record.visitorCertificateNoEncrypt
      getCheckLogList({ ticketInfoId: record.id, limit: 999, page: 1 }).then(res => {
        if (res.code === 0) {
          this.checkInfo = res.data
          if (this.checkInfo && this.checkInfo.length !== 0) {
            this.checkInfo.forEach(item => {
              for (const ot of this.checkType) {
                if (ot.code === item.checkType) {
                  item.checkType = ot.value
                  break
                }
              }
            })
          }
        } else {
          this.$message.error('请求出错了')
        }
      })
    },
    handleChildrenInfo (row) {
      handleChildrenInfo({ parentTicketNo: row.ticketNo }).then(res => {
        if (res.code === 0) {
          this.childrenList = res.data
          this.childrenShow = true
        }
      })
    },
    backAndClose () {
      this.$emit('backAndClose')
    },
    cancel () {
      this.dialogCompVisible = false
      this.checkInfo = []
      this.form = {}
    },
    qrCode (row) {
      this.qcCodeSelect = row
      document.getElementById('qrcode').innerHTML = ''
      let qrcode = new QRCode('qrcode', {
        width: 200, // 图像宽度
        height: 200, // 图像高度
        colorDark: '#000000', // 前景色
        colorLight: '#ffffff', // 背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H // 容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
      })
      qrcode.clear() // 清除二维码
      qrcode.makeCode(row.ticketNo) // 生成另一个新的二维码

      //
      let qrcodeChange = document.getElementById('qrcode').getElementsByTagName('img')[0]
      let name = document.createElement('div')
      name.innerText = row.visitorName
      name.style.cssText = 'margin-top: 50px;'
      qrcodeChange.parentNode.insertBefore(name, qrcodeChange.nextSibling)
      //
      this.qrcode = true
    }
  }
}
</script>
<style lang="scss" scoped>
.order-info{

  form{
    .search-form-inline{
      border: 1px solid #EBEEF5;
      margin: 40px auto;
      margin-top: 5px;
    }
  }
}
.ticket{
    margin: 0 auto;
}
.title {
    position: relative;
    font-size: 18px;
    line-height: 65px;
    padding-left: 25px;
    font-weight: bold;
    margin: 0 auto;
    &::before {
      position: absolute;
      top: 50%;
      left: 0;
      width: 5px;
      height: 28px;
      background: #c09430;
      content: "";
      margin-top: -14px;
    }
  }
  .qrcode-box{
    width: 100%;
    height: 100%;
    z-index: 1000;
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(110, 100, 100, 0.5);
    .qc-box-2{
      position: relative;
      width: 375px;
      height: 618px;
      background: #FFFFFF;
      opacity: 1;
      border-radius: 12px;
      margin: 100px auto;
      .userName{
        position: absolute;
        top: 400px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: bold;
      }
      .hint{
        width: 100%;
        position: absolute;
        bottom: 87px;
        left: 50%;
        transform: translateX(-50%);
        color: #E34E4E;
        opacity: 1;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: bold;
      }
      .icon {
        width: 92px;
        height: 92px;
        background: #71A6FA;
        border: 3px solid #FFFFFF;
        box-shadow: 0px 3px 6px rgba(41, 46, 52, 0.08);
        border-radius: 50%;
        opacity: 1;
        position: absolute;
        top: -46px;
        left: 50%;
        transform: translateX(-50%);
        img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .title-text {
        position: absolute;
        top: 62px;
        left: 50%;
        transform: translateX(-50%);
        .p1 {
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #0D1720;
        }
        .p2 {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          line-height: 20px;
        }
      }
    }
    .qrcode{
      background: #fff;
      width: 200px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 67px 45px;
      border:  1px dashed #707070;
      img {
        border: 1px solid #707070;
      }
    }
    .closeIcon {
      position: absolute;
      bottom: 15px;
      left: 50%;
      width: 40px;
      height: 40px;
      transform: translateX(-50%);
      cursor: pointer;
    }
  }
  .pointer{
    cursor: pointer;
  }
</style>
